import { render, staticRenderFns } from "./CreatePolymerType.vue?vue&type=template&id=cc208690&"
import script from "./CreatePolymerType.vue?vue&type=script&lang=js&"
export * from "./CreatePolymerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports